module.exports = __webpack_public_path__ + "static/media/analyse.18821d9b.png";